/**
 * @generated SignedSource<<e514bdd13b3bf31150ca8e6a35cab245>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "%future added value";
export type INHERIT_DATES_FROM_TYPE = "BASELINE" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectScopingPage_viewer$data = {
  readonly id: string;
  readonly language: LANGUAGE | null;
  readonly email: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly timerStartDate: string | null;
  readonly actualPersonId: string | null;
  readonly harvestUser: boolean | null;
  readonly unit4User: boolean | null;
  readonly excludeFromCompanyLockedPeriod: boolean | null;
  readonly submitLockedDateYear: number | null;
  readonly submitLockedDateMonth: number | null;
  readonly submitLockedDateDay: number | null;
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly createdAt: string | null;
  readonly monday: number | null;
  readonly tuesday: number | null;
  readonly wednesday: number | null;
  readonly thursday: number | null;
  readonly friday: number | null;
  readonly saturday: number | null;
  readonly sunday: number | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly timerTask: {
    readonly id: string;
  } | null;
  readonly company: {
    readonly jiraCloudEnabled: boolean | null;
    readonly jiraServerEnabled: boolean | null;
    readonly sageIntacctConnectionEnabled: boolean | null;
    readonly integrations: {
      readonly jiraCloud: {
        readonly syncSettings: {
          readonly isJiraToForecastOneWaySync: boolean | null;
        } | null;
      } | null;
      readonly jiraServer: {
        readonly syncSettings: {
          readonly isJiraToForecastOneWaySync: boolean | null;
        } | null;
      } | null;
    } | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly person: {
      readonly id: string;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly isUsingProjectAllocation: boolean | null;
    readonly isUsingMixedAllocation: boolean | null;
    readonly holidayCalendars: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly holidayCalendarEntries: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly year: number | null;
                readonly month: number | null;
                readonly day: number | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly allPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly id: string;
    readonly currency: string | null;
    readonly harvestEnabled: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
          readonly category: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"LabelDropdownJS_labels">;
        } | null;
      } | null> | null;
    } | null;
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"RoleDropdown_roles">;
      } | null> | null;
    } | null;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly teamPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly customFieldDefinitionsV2?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly key: string;
          readonly displayName: string;
          readonly entityType: string;
          readonly readOnly?: boolean;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"genericTaskContextMenu_company">;
  } | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly name: string | null;
        readonly status: PROJECT_STATUS | null;
        readonly isInProjectGroup: boolean | null;
        readonly projectColor: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly project: {
    readonly projectFirstDateYear: number | null;
    readonly projectFirstDateMonth: number | null;
    readonly projectFirstDateDay: number | null;
    readonly projectLastDateYear: number | null;
    readonly projectLastDateMonth: number | null;
    readonly projectLastDateDay: number | null;
    readonly baselineTargetPrice: number | null;
    readonly baselineTargetMinutes: number | null;
    readonly id: string;
    readonly isNoStaleTasksAllowed: boolean | null;
    readonly name: string | null;
    readonly demo: boolean | null;
    readonly budgetWork: number | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
    readonly budget: number | null;
    readonly billable: boolean | null;
    readonly synchBaselineAndScopingDates: boolean | null;
    readonly program: {
      readonly name: string | null;
      readonly prefix: string | null;
      readonly budgetType: PROGRAM_BUDGET_TYPE | null;
      readonly members: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly role: string | null;
            readonly person: {
              readonly id: string;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly sprintTimeBox: boolean | null;
    readonly isInProjectGroup: boolean | null;
    readonly useBaseline: boolean | null;
    readonly projectGroupId: string | null;
    readonly status: PROJECT_STATUS | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly estimationUnit: string | null;
    readonly minutesPerEstimationPoint: number | null;
    readonly timeRegistrations?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly minutesRegistered: number | null;
          readonly billableMinutesRegistered: number | null;
          readonly invoiced: boolean | null;
          readonly price: number | null;
          readonly updatedAt: string | null;
          readonly year: number | null;
          readonly month: number | null;
          readonly day: number | null;
          readonly retainerConflictHandled: boolean | null;
          readonly task: {
            readonly id: string;
          } | null;
          readonly person: {
            readonly id: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly retainerPeriods: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly endYear: number | null;
          readonly endMonth: number | null;
          readonly endDay: number | null;
          readonly available: number | null;
          readonly periodLength: number | null;
          readonly periodPeriodicity: PERIODICITY | null;
          readonly periodPriceAmount: number | null;
          readonly periodHoursAmount: number | null;
          readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
          readonly periodSettingIgnoreForBilling: boolean | null;
          readonly periodSettingSubtractValue: boolean | null;
          readonly periodSettingRollValue: boolean | null;
          readonly periodSettingAddExpenses: boolean | null;
          readonly periodDifferencePriceAmount: number | null;
          readonly periodDifferenceHoursAmount: number | null;
          readonly sharedPeriodDifferenceHoursAmount: number | null;
          readonly sharedPeriodDifferencePriceAmount: number | null;
          readonly ignoredRolloverHours: number | null;
          readonly ignoredRolloverPrice: number | null;
          readonly periodLocked: boolean | null;
          readonly periodLockedTime: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly projectColor: string | null;
    readonly projectStartYear: number | null;
    readonly projectStartMonth: number | null;
    readonly projectStartDay: number | null;
    readonly projectEndYear: number | null;
    readonly projectEndMonth: number | null;
    readonly projectEndDay: number | null;
    readonly useManualAllocations: boolean | null;
    readonly remainingAutoCalculated: boolean | null;
    readonly isJiraProject: boolean | null;
    readonly useTaskOwner: boolean | null;
    readonly useTaskFollowers: boolean | null;
    readonly taskLevels: number | null;
    readonly useTaskHierarchy: boolean | null;
    readonly useDeliverables: boolean | null;
    readonly deliverables: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly vstsProject: string | null;
    readonly vstsAccount: string | null;
    readonly harvestProjectId: string | null;
    readonly vstsTwoWaySync: boolean | null;
    readonly jiraSubtaskType: string | null;
    readonly progress: number | null;
    readonly manualProgressOnProjectEnabled: boolean | null;
    readonly manualProgressOnPhasesEnabled: boolean | null;
    readonly manualProgressOnTasksEnabled: boolean | null;
    readonly financialSourceSettings: {
      readonly plannedHours: string | null;
      readonly plannedRevenue: string | null;
      readonly plannedCost: string | null;
      readonly actualRevenue: string | null;
      readonly actualCost: string | null;
      readonly forecastRevenue: string | null;
      readonly actualHours: string | null;
    } | null;
    readonly jiraCloudProject: {
      readonly id: string;
    } | null;
    readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
    readonly jiraServerProject: {
      readonly id: string;
    } | null;
    readonly sageProject: {
      readonly sageProjectId: string | null;
    } | null;
    readonly statusColumnsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly order: number | null;
          readonly jiraStatusId: string | null;
          readonly category: STATUS_CATEGORY | null;
        } | null;
      } | null> | null;
    } | null;
    readonly rateCard: {
      readonly id: string;
      readonly currency: string | null;
      readonly rates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly rate: number | null;
            readonly defaultRate: boolean | null;
            readonly startDate: string | null;
            readonly role: {
              readonly id: string;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly disabledRoles: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
    } | null;
    readonly projectPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly person: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly initials: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly active: boolean | null;
            readonly monday: number | null;
            readonly tuesday: number | null;
            readonly wednesday: number | null;
            readonly thursday: number | null;
            readonly friday: number | null;
            readonly saturday: number | null;
            readonly sunday: number | null;
            readonly holidayCalendar: {
              readonly id: string;
            } | null;
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
            readonly client: {
              readonly id: string;
            } | null;
            readonly allocations: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly monday: number | null;
                  readonly tuesday: number | null;
                  readonly wednesday: number | null;
                  readonly thursday: number | null;
                  readonly friday: number | null;
                  readonly saturday: number | null;
                  readonly sunday: number | null;
                  readonly startYear: number | null;
                  readonly startMonth: number | null;
                  readonly startDay: number | null;
                  readonly endYear: number | null;
                  readonly endMonth: number | null;
                  readonly endDay: number | null;
                  readonly idleTime: {
                    readonly isInternalTime: boolean | null;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly phases: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly baselineTargetPrice: number | null;
          readonly baselineTargetMinutes: number | null;
          readonly baselineCost: number | null;
          readonly inheritDatesFrom: INHERIT_DATES_FROM_TYPE | null;
          readonly progress: number | null;
          readonly progressDetails: {
            readonly progress: number | null;
          } | null;
          readonly phaseBaselineRoles: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly role: {
                  readonly id: string;
                } | null;
                readonly baselineMinutes: number | null;
                readonly baselinePrice: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly startFrom: string | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly deadlineFrom: string | null;
          readonly baselineStartYear: number | null;
          readonly baselineStartMonth: number | null;
          readonly baselineStartDay: number | null;
          readonly baselineDeadlineDay: number | null;
          readonly baselineDeadlineMonth: number | null;
          readonly baselineDeadlineYear: number | null;
          readonly unit4Id: string | null;
          readonly jiraId: string | null;
          readonly sortOrder: number | null;
          readonly phasePersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly availableMinutes: number | null;
                readonly scheduledMinutes: number | null;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly customFields?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly key: string;
                readonly displayName: string;
                readonly value: string | null;
                readonly type: string;
                readonly readOnly?: boolean;
                readonly options?: ReadonlyArray<{
                  readonly id: string;
                  readonly displayName: string;
                } | null>;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly baselineFinancialNumbers: ReadonlyArray<{
      readonly baselineRevenue: number | null;
      readonly baselineTimeAndExpenses: number | null;
      readonly baselineCost: number | null;
      readonly baselineProfit: number | null;
      readonly baselineMargin: number | null;
      readonly baselineRatePerHour: number | null;
      readonly baselineCostPerHour: number | null;
      readonly baselineMinutes: number | null;
      readonly phaseBaselineRoleId: number | null;
      readonly phaseBaselineExpenseId: number | null;
      readonly phaseId: number | null;
    } | null> | null;
    readonly sprints: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly endYear: number | null;
          readonly endMonth: number | null;
          readonly endDay: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly tasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly userCanDeleteTask: boolean | null;
          readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
          readonly hasInvoicedTime: boolean | null;
          readonly hasLockedTime: boolean | null;
          readonly hasTimeRegistrations: boolean | null;
          readonly approved: boolean | null;
          readonly name: string | null;
          readonly description: string | null;
          readonly sortOrder: number | null;
          readonly done: boolean | null;
          readonly billable: boolean | null;
          readonly blocked: boolean | null;
          readonly progress?: number | null;
          readonly currentPrice?: number | null;
          readonly actualCost?: number | null;
          readonly plannedCost?: number | null;
          readonly timeLeft?: number | null;
          readonly timeRegistrations?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly minutesRegistered: number | null;
                readonly billableMinutesRegistered: number | null;
                readonly price: number | null;
                readonly invoiced: boolean | null;
                readonly year: number | null;
                readonly month: number | null;
                readonly day: number | null;
                readonly retainerConflictHandled: boolean | null;
                readonly person: {
                  readonly id: string;
                  readonly role: {
                    readonly id: string;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly bug: boolean | null;
          readonly latestUiUpdateAt: string | null;
          readonly startFrom: string | null;
          readonly deadlineFrom: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly estimateForecast: number | null;
          readonly estimateForecastMinutes: number | null;
          readonly estimateForecastPrice: number | null;
          readonly totalPriceAtCompletion: number | null;
          readonly totalCostAtCompletion: number | null;
          readonly allTotalTimeAndExpensesAtCompletion: number | null;
          readonly companyTaskId: number | null;
          readonly canStart: boolean | null;
          readonly canBeSetToDone: boolean | null;
          readonly highPriority: boolean | null;
          readonly hasDependency: boolean | null;
          readonly jiraId: string | null;
          readonly vstsId: string | null;
          readonly isUnit4Task: boolean | null;
          readonly subTaskCount: number | null;
          readonly parentTaskId: string | null;
          readonly deliverableId: string | null;
          readonly hasChildren: boolean | null;
          readonly sageIntacctId: string | null;
          readonly favoured: boolean | null;
          readonly progressDetails: {
            readonly progress: number | null;
          } | null;
          readonly owner: {
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null> | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly startYear: number | null;
            readonly startMonth: number | null;
            readonly startDay: number | null;
            readonly startFrom: string | null;
            readonly deadlineDay: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineYear: number | null;
            readonly deadlineFrom: string | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly sprint: {
            readonly id: string;
            readonly name: string | null;
            readonly startYear: number | null;
            readonly startMonth: number | null;
            readonly startDay: number | null;
            readonly endYear: number | null;
            readonly endMonth: number | null;
            readonly endDay: number | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly project: {
            readonly id: string;
            readonly demo: boolean | null;
            readonly billable: boolean | null;
            readonly estimationUnit: string | null;
            readonly minutesPerEstimationPoint: number | null;
            readonly projectStartYear: number | null;
            readonly projectStartMonth: number | null;
            readonly projectStartDay: number | null;
            readonly projectEndYear: number | null;
            readonly projectEndMonth: number | null;
            readonly projectEndDay: number | null;
            readonly budgetType: BUDGET_TYPE | null;
            readonly projectPerson: {
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
            readonly program: {
              readonly name: string | null;
              readonly prefix: string | null;
              readonly budgetType: PROGRAM_BUDGET_TYPE | null;
              readonly members: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly role: string | null;
                    readonly person: {
                      readonly id: string;
                    } | null;
                  } | null;
                } | null> | null;
              } | null;
            } | null;
            readonly name: string | null;
            readonly status: PROJECT_STATUS | null;
            readonly isJiraProject: boolean | null;
            readonly vstsProject: string | null;
            readonly vstsAccount: string | null;
            readonly vstsTwoWaySync: boolean | null;
            readonly projectColor: string | null;
            readonly companyProjectId: number | null;
            readonly customProjectId: string | null;
            readonly harvestProject: {
              readonly id: string;
            } | null;
            readonly unit4Project: {
              readonly id: string;
              readonly activitiesEnabled: boolean | null;
            } | null;
            readonly sprintTimeBox: boolean | null;
          } | null;
          readonly taskLabels: ReadonlyArray<{
            readonly id: string;
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly taskDismissedNotifications: {
            readonly taskOverrunPredictionDismissed: boolean | null;
          } | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly active: boolean | null;
            readonly email: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null> | null;
          readonly thisTaskDependsOn: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly type: DEPENDENCY_TYPE | null;
                readonly thisDependsOnTask: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly deadlineYear: number | null;
                  readonly deadlineMonth: number | null;
                  readonly deadlineDay: number | null;
                  readonly startYear: number | null;
                  readonly startMonth: number | null;
                  readonly startDay: number | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly customFields?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly key: string;
                readonly displayName: string;
                readonly value: string | null;
                readonly type: string;
                readonly readOnly?: boolean;
                readonly options?: ReadonlyArray<{
                  readonly id: string;
                  readonly displayName: string;
                } | null>;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly allocations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly monday: number | null;
          readonly tuesday: number | null;
          readonly wednesday: number | null;
          readonly thursday: number | null;
          readonly friday: number | null;
          readonly saturday: number | null;
          readonly sunday: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly endYear: number | null;
          readonly endMonth: number | null;
          readonly endDay: number | null;
          readonly person: {
            readonly id: string;
            readonly role: {
              readonly id: string;
            } | null;
            readonly holidayCalendar: {
              readonly id: string;
            } | null;
          } | null;
          readonly project: {
            readonly id: string;
          } | null;
          readonly isSoft: boolean | null;
        } | null;
      } | null> | null;
    } | null;
    readonly expenseFinancialNumbers: {
      readonly allTotalTimeAndExpensesAtCompletion: number | null;
    } | null;
    readonly totalFinancialNumbers: {
      readonly totalCostAtCompletion: number | null;
      readonly totalRevenueRecognition: number | null;
      readonly totalRevenueProfitAtCompletion: number | null;
      readonly totalRevenueMarginAtCompletion: number | null;
      readonly forecastMinutes: number | null;
      readonly registeredMinutes: number | null;
      readonly billableActualMinutes: number | null;
      readonly nonBillableActualMinutes: number | null;
      readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      readonly baselineMinutes: number | null;
      readonly allocationMinutes: number | null;
      readonly scopeApprovedMinutes: number | null;
      readonly remainingMinutes: number | null;
      readonly baselineRevenue: number | null;
      readonly plannedCost: number | null;
      readonly actualCost: number | null;
      readonly projectedBillableMinutes: number | null;
      readonly projectedNonBillableMinutes: number | null;
      readonly projectedTotalMinutes: number | null;
      readonly plannedRevenue: number | null;
      readonly plannedProfit: number | null;
      readonly plannedMargin: number | null;
      readonly baselineMargin: number | null;
      readonly remainingCost: number | null;
      readonly actualRevenue: number | null;
      readonly baselineCost: number | null;
      readonly baselineProfit: number | null;
      readonly billableActualTimeAndExpenses: number | null;
      readonly nonBillableActualTimeAndExpenses: number | null;
      readonly baselineTimeAndExpenses: number | null;
      readonly allTotalTimeAndExpensesAtCompletion: number | null;
      readonly taskRegisteredMinutes: number | null;
      readonly projectRegisteredMinutes: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_project" | "SecondaryNavigation_project">;
  } | null;
  readonly psProject: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_psProject">;
  } | null;
  readonly " $fragmentType": "ProjectScopingPage_viewer";
};
export type ProjectScopingPage_viewer$key = {
  readonly " $data"?: ProjectScopingPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectScopingPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v14 = [
  (v1/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  (v1/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v26 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v28 = [
  (v26/*: any*/)
],
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v32 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetPrice",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetMinutes",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgramType",
  "kind": "LinkedField",
  "name": "program",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefix",
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectServiceProgramMemberTypeConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                (v30/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retainerConflictHandled",
  "storageKey": null
},
v54 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedRevenue",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedCost",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v77 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v85 = [
  (v71/*: any*/)
],
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMinutes",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v95 = {
  "condition": "fetchCustomFields",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomFieldValueV2TypeConnection",
      "kind": "LinkedField",
      "name": "customFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomFieldValueV2TypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v22/*: any*/),
                (v13/*: any*/),
                (v31/*: any*/),
                (v33/*: any*/),
                (v94/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v32/*: any*/),
                  "type": "TextCustomFieldValue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomFieldDropdownOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        (v31/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "DropdownCustomFieldValue",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v96 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineRevenue",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTimeAndExpenses",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMargin",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCostAtCompletion",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v104 = [
  (v1/*: any*/),
  (v103/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchCustomFields"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchLazyData"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noStaleTasks"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "holidayCalendars"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "allPersons"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "customFieldDefinitionsV2"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "timeRegistrations"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "deliverables"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "phases"
        ]
      },
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "tasks"
        ]
      }
    ]
  },
  "name": "ProjectScopingPage_viewer",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4User",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludeFromCompanyLockedPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateDay",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        (v13/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "genericTaskContextMenu_company"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraServerEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctConnectionEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyIntegrationsType",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyJiraSettingsType",
              "kind": "LinkedField",
              "name": "jiraCloud",
              "plural": false,
              "selections": (v15/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyJiraSettingsType",
              "kind": "LinkedField",
              "name": "jiraServer",
              "plural": false,
              "selections": (v15/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "personId"
            }
          ],
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingMixedAllocation",
          "storageKey": null
        },
        {
          "alias": "holidayCalendars",
          "args": null,
          "concreteType": "HolidayCalendarTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_holidayCalendars_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HolidayCalendarTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HolidayCalendar",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": "holidayCalendarEntries",
                      "args": null,
                      "concreteType": "HolidayCalendarEntryTypeConnection",
                      "kind": "LinkedField",
                      "name": "__HolidayCalendar_holidayCalendarEntries_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "HolidayCalendarEntryTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "HolidayCalendarEntry",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v16/*: any*/),
                                (v19/*: any*/),
                                (v20/*: any*/),
                                (v21/*: any*/),
                                (v22/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v23/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v24/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "allPersons",
          "args": null,
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_allPersons_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        (v1/*: any*/),
        (v25/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v26/*: any*/),
            {
              "kind": "Literal",
              "name": "labelType",
              "value": "TASK"
            }
          ],
          "concreteType": "LabelTypeConnection",
          "kind": "LinkedField",
          "name": "labels",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LabelTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    (v27/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LabelCategory",
                      "kind": "LinkedField",
                      "name": "category",
                      "plural": false,
                      "selections": (v17/*: any*/),
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "LabelDropdownJS_labels"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "labels(first:1000000,labelType:\"TASK\")"
        },
        {
          "alias": null,
          "args": (v28/*: any*/),
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RoleDropdown_roles"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v17/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "roles(first:1000000)"
        },
        {
          "alias": null,
          "args": (v28/*: any*/),
          "concreteType": "TeamTypeConnection",
          "kind": "LinkedField",
          "name": "teams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": (v29/*: any*/),
                      "concreteType": "TeamPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "teamPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TeamPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TeamPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v30/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "teamPersons(first:1000)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "teams(first:1000000)"
        },
        {
          "condition": "fetchCustomFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "customFieldDefinitionsV2",
              "args": null,
              "concreteType": "CustomFieldDefinitionV2TypeConnection",
              "kind": "LinkedField",
              "name": "__Company_customFieldDefinitionsV2_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomFieldDefinitionV2TypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v13/*: any*/),
                        (v31/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityType",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v32/*: any*/),
                          "type": "TextCustomField",
                          "abstractKey": null
                        },
                        (v22/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v23/*: any*/)
                  ],
                  "storageKey": null
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                (v33/*: any*/),
                (v34/*: any*/),
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeRestricted",
          "value": true
        },
        (v26/*: any*/)
      ],
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "projects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v35/*: any*/),
                (v36/*: any*/),
                (v16/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projects(excludeRestricted:true,first:1000000)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectHeader_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SecondaryNavigation_project"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateDay",
          "storageKey": null
        },
        (v40/*: any*/),
        (v41/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNoStaleTasksAllowed",
          "storageKey": null
        },
        (v16/*: any*/),
        (v42/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetWork",
          "storageKey": null
        },
        (v43/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultPeriodBudgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budget",
          "storageKey": null
        },
        (v44/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "synchBaselineAndScopingDates",
          "storageKey": null
        },
        (v45/*: any*/),
        (v46/*: any*/),
        (v38/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useBaseline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupId",
          "storageKey": null
        },
        (v37/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        {
          "condition": "fetchLazyData",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "timeRegistrations",
              "args": null,
              "concreteType": "TimeRegTypeConnection",
              "kind": "LinkedField",
              "name": "__Project_timeRegistrations_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeRegTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeRegType",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v49/*: any*/),
                        (v50/*: any*/),
                        (v51/*: any*/),
                        (v52/*: any*/),
                        (v34/*: any*/),
                        (v19/*: any*/),
                        (v20/*: any*/),
                        (v21/*: any*/),
                        (v53/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Task",
                          "kind": "LinkedField",
                          "name": "task",
                          "plural": false,
                          "selections": (v14/*: any*/),
                          "storageKey": null
                        },
                        (v30/*: any*/),
                        (v22/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v23/*: any*/)
                  ],
                  "storageKey": null
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": (v54/*: any*/),
          "concreteType": "RetainerPeriodTypeConnection",
          "kind": "LinkedField",
          "name": "retainerPeriods",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RetainerPeriodTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RetainerPeriodType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/),
                    (v58/*: any*/),
                    (v59/*: any*/),
                    (v60/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "available",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodLength",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodPeriodicity",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodPriceAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodHoursAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodBudgetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodSettingIgnoreForBilling",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodSettingSubtractValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodSettingRollValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodSettingAddExpenses",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodDifferencePriceAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodDifferenceHoursAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sharedPeriodDifferenceHoursAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sharedPeriodDifferencePriceAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ignoredRolloverHours",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ignoredRolloverPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodLocked",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "periodLockedTime",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "retainerPeriods(first:100000)"
        },
        (v39/*: any*/),
        (v61/*: any*/),
        (v62/*: any*/),
        (v63/*: any*/),
        (v64/*: any*/),
        (v65/*: any*/),
        (v66/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useManualAllocations",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingAutoCalculated",
          "storageKey": null
        },
        (v67/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskFollowers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskLevels",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskHierarchy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useDeliverables",
          "storageKey": null
        },
        {
          "alias": "deliverables",
          "args": null,
          "concreteType": "DeliverableTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_deliverables_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeliverableTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DeliverableType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        (v68/*: any*/),
        (v69/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestProjectId",
          "storageKey": null
        },
        (v70/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraSubtaskType",
          "storageKey": null
        },
        (v71/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnProjectEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnPhasesEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnTasksEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialSourceSettings",
          "kind": "LinkedField",
          "name": "financialSourceSettings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedHours",
              "storageKey": null
            },
            (v72/*: any*/),
            (v73/*: any*/),
            (v74/*: any*/),
            (v75/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastRevenue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualHours",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectType",
          "kind": "LinkedField",
          "name": "jiraCloudProject",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEpicIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerProjectType",
          "kind": "LinkedField",
          "name": "jiraServerProject",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SageProjectType",
          "kind": "LinkedField",
          "name": "sageProject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sageProjectId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v28/*: any*/),
          "concreteType": "StatusColumnV2TypeConnection",
          "kind": "LinkedField",
          "name": "statusColumnsV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StatusColumnV2TypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusColumnV2",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "order",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jiraStatusId",
                      "storageKey": null
                    },
                    (v76/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "statusColumnsV2(first:1000000)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v25/*: any*/),
            {
              "alias": null,
              "args": (v77/*: any*/),
              "concreteType": "RateTypeConnection",
              "kind": "LinkedField",
              "name": "rates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RateTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Rate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "defaultRate",
                          "storageKey": null
                        },
                        (v5/*: any*/),
                        (v78/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "rates(first:10000)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "disabledRoles",
              "plural": true,
              "selections": (v14/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v28/*: any*/),
          "concreteType": "ProjectPersonTypeConnection",
          "kind": "LinkedField",
          "name": "projectPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectPerson",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v18/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v79/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "initials",
                          "storageKey": null
                        },
                        (v80/*: any*/),
                        (v81/*: any*/),
                        (v82/*: any*/),
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        (v11/*: any*/),
                        (v12/*: any*/),
                        (v83/*: any*/),
                        (v18/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Client",
                          "kind": "LinkedField",
                          "name": "client",
                          "plural": false,
                          "selections": (v14/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": [
                            (v26/*: any*/),
                            {
                              "kind": "Literal",
                              "name": "idleTimeOnly",
                              "value": true
                            }
                          ],
                          "concreteType": "AllocationTypeConnection",
                          "kind": "LinkedField",
                          "name": "allocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AllocationTypeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Allocation",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v6/*: any*/),
                                    (v7/*: any*/),
                                    (v8/*: any*/),
                                    (v9/*: any*/),
                                    (v10/*: any*/),
                                    (v11/*: any*/),
                                    (v12/*: any*/),
                                    (v55/*: any*/),
                                    (v56/*: any*/),
                                    (v57/*: any*/),
                                    (v58/*: any*/),
                                    (v59/*: any*/),
                                    (v60/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "IdleTime",
                                      "kind": "LinkedField",
                                      "name": "idleTime",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "isInternalTime",
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "allocations(first:1000000,idleTimeOnly:true)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "projectPersons(first:1000000)"
        },
        {
          "alias": "phases",
          "args": null,
          "concreteType": "PhaseTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_phases_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PhaseType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/),
                    (v41/*: any*/),
                    (v84/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inheritDatesFrom",
                      "storageKey": null
                    },
                    (v71/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhaseProgress",
                      "kind": "LinkedField",
                      "name": "progressDetails",
                      "plural": false,
                      "selections": (v85/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhaseBaselineRoleTypeConnection",
                      "kind": "LinkedField",
                      "name": "phaseBaselineRoles",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PhaseBaselineRoleTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PhaseBaselineRoleType",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v78/*: any*/),
                                (v86/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "baselinePrice",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    (v16/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/),
                    (v87/*: any*/),
                    (v88/*: any*/),
                    (v89/*: any*/),
                    (v90/*: any*/),
                    (v91/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineStartYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineStartMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineStartDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineDeadlineDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineDeadlineMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baselineDeadlineYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unit4Id",
                      "storageKey": null
                    },
                    (v92/*: any*/),
                    (v93/*: any*/),
                    {
                      "alias": null,
                      "args": (v77/*: any*/),
                      "concreteType": "PhasePersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "phasePersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PhasePersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PhasePerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "availableMinutes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "scheduledMinutes",
                                  "storageKey": null
                                },
                                (v30/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "phasePersons(first:10000)"
                    },
                    (v95/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "baselineFinancialNumbers",
          "args": [
            (v96/*: any*/),
            {
              "kind": "Literal",
              "name": "groupBy",
              "value": [
                "PHASE_BASELINE_ROLE",
                "PHASE"
              ]
            }
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "groupedFinancialNumbers",
          "plural": true,
          "selections": [
            (v97/*: any*/),
            (v98/*: any*/),
            (v84/*: any*/),
            (v99/*: any*/),
            (v100/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineRatePerHour",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineCostPerHour",
              "storageKey": null
            },
            (v86/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phaseBaselineRoleId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phaseBaselineExpenseId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phaseId",
              "storageKey": null
            }
          ],
          "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"PHASE_BASELINE_ROLE\",\"PHASE\"])"
        },
        {
          "alias": null,
          "args": (v28/*: any*/),
          "concreteType": "SprintTypeConnection",
          "kind": "LinkedField",
          "name": "sprints",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v16/*: any*/),
                    (v58/*: any*/),
                    (v59/*: any*/),
                    (v60/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "sprints(first:1000000)"
        },
        {
          "alias": "tasks",
          "args": null,
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_tasks_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskReadOnly",
                      "kind": "LinkedField",
                      "name": "readOnly",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isReadOnly",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userCanDeleteTask",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userCantDeleteTaskReason",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvoicedTime",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasLockedTime",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasTimeRegistrations",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "approved",
                      "storageKey": null
                    },
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    (v93/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "done",
                      "storageKey": null
                    },
                    (v44/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "blocked",
                      "storageKey": null
                    },
                    {
                      "condition": "fetchLazyData",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v71/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentPrice",
                          "storageKey": null
                        },
                        (v75/*: any*/),
                        (v73/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timeLeft",
                          "storageKey": null
                        },
                        {
                          "alias": "timeRegistrations",
                          "args": null,
                          "concreteType": "TimeRegTypeConnection",
                          "kind": "LinkedField",
                          "name": "__Task_timeRegistrations_connection",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TimeRegTypeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "TimeRegType",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v49/*: any*/),
                                    (v50/*: any*/),
                                    (v52/*: any*/),
                                    (v51/*: any*/),
                                    (v19/*: any*/),
                                    (v20/*: any*/),
                                    (v21/*: any*/),
                                    (v53/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Person",
                                      "kind": "LinkedField",
                                      "name": "person",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        (v78/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v22/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v23/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v24/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latestUiUpdateAt",
                      "storageKey": null
                    },
                    (v87/*: any*/),
                    (v91/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/),
                    (v88/*: any*/),
                    (v89/*: any*/),
                    (v90/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "estimateForecast",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "estimateForecastMinutes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "estimateForecastPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPriceAtCompletion",
                      "storageKey": null
                    },
                    (v101/*: any*/),
                    (v102/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canStart",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canBeSetToDone",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "highPriority",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasDependency",
                      "storageKey": null
                    },
                    (v92/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vstsId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isUnit4Task",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "subTaskCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "parentTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deliverableId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasChildren",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sageIntacctId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "favoured",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskProgress",
                      "kind": "LinkedField",
                      "name": "progressDetails",
                      "plural": false,
                      "selections": (v85/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "owner",
                      "plural": false,
                      "selections": (v104/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "followers",
                      "plural": true,
                      "selections": (v104/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhaseType",
                      "kind": "LinkedField",
                      "name": "phase",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v16/*: any*/),
                        (v55/*: any*/),
                        (v56/*: any*/),
                        (v57/*: any*/),
                        (v87/*: any*/),
                        (v88/*: any*/),
                        (v89/*: any*/),
                        (v90/*: any*/),
                        (v91/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v18/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sprint",
                      "kind": "LinkedField",
                      "name": "sprint",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v16/*: any*/),
                        (v55/*: any*/),
                        (v56/*: any*/),
                        (v57/*: any*/),
                        (v58/*: any*/),
                        (v59/*: any*/),
                        (v60/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnV2",
                      "kind": "LinkedField",
                      "name": "statusColumnV2",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v16/*: any*/),
                        (v76/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v42/*: any*/),
                        (v44/*: any*/),
                        (v47/*: any*/),
                        (v48/*: any*/),
                        (v61/*: any*/),
                        (v62/*: any*/),
                        (v63/*: any*/),
                        (v64/*: any*/),
                        (v65/*: any*/),
                        (v66/*: any*/),
                        (v43/*: any*/),
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "personId",
                              "variableName": "personId"
                            }
                          ],
                          "concreteType": "ProjectPerson",
                          "kind": "LinkedField",
                          "name": "projectPerson",
                          "plural": false,
                          "selections": [
                            (v18/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v45/*: any*/),
                        (v16/*: any*/),
                        (v37/*: any*/),
                        (v67/*: any*/),
                        (v68/*: any*/),
                        (v69/*: any*/),
                        (v70/*: any*/),
                        (v39/*: any*/),
                        (v35/*: any*/),
                        (v36/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "HarvestProjectType",
                          "kind": "LinkedField",
                          "name": "harvestProject",
                          "plural": false,
                          "selections": (v14/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Unit4ProjectType",
                          "kind": "LinkedField",
                          "name": "unit4Project",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "activitiesEnabled",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v46/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskLabel",
                      "kind": "LinkedField",
                      "name": "taskLabels",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Label",
                          "kind": "LinkedField",
                          "name": "label",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v16/*: any*/),
                            (v27/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskDismissedNotifications",
                      "kind": "LinkedField",
                      "name": "taskDismissedNotifications",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "taskOverrunPredictionDismissed",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "assignedPersons",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v79/*: any*/),
                        (v82/*: any*/),
                        (v2/*: any*/),
                        (v80/*: any*/),
                        (v81/*: any*/),
                        (v103/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": (v29/*: any*/),
                      "concreteType": "DependencyTypeConnection",
                      "kind": "LinkedField",
                      "name": "thisTaskDependsOn",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DependencyTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DependencyType",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v94/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Task",
                                  "kind": "LinkedField",
                                  "name": "thisDependsOnTask",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v16/*: any*/),
                                    (v90/*: any*/),
                                    (v89/*: any*/),
                                    (v88/*: any*/),
                                    (v55/*: any*/),
                                    (v56/*: any*/),
                                    (v57/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "thisTaskDependsOn(first:1000)"
                    },
                    (v95/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v54/*: any*/),
          "concreteType": "AllocationTypeConnection",
          "kind": "LinkedField",
          "name": "allocations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AllocationTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Allocation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/),
                    (v58/*: any*/),
                    (v59/*: any*/),
                    (v60/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v78/*: any*/),
                        (v83/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v14/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSoft",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allocations(first:100000)"
        },
        {
          "alias": "expenseFinancialNumbers",
          "args": [
            (v96/*: any*/),
            {
              "kind": "Literal",
              "name": "searchQuery",
              "value": {
                "filters": [
                  {
                    "field": "ROLE",
                    "operator": "IS",
                    "value": "Um9sZTotMQ=="
                  }
                ]
              }
            }
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "financialNumbers",
          "plural": false,
          "selections": [
            (v102/*: any*/)
          ],
          "storageKey": "financialNumbers(convertToProjectCurrency:true,searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"IS\",\"value\":\"Um9sZTotMQ==\"}]})"
        },
        {
          "alias": "totalFinancialNumbers",
          "args": [
            (v96/*: any*/)
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "financialNumbers",
          "plural": false,
          "selections": [
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueMarginAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "registeredMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableActualMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nonBillableActualMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableTotalTimeAndExpensesAtCompletion",
              "storageKey": null
            },
            (v86/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allocationMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scopeApprovedMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingMinutes",
              "storageKey": null
            },
            (v97/*: any*/),
            (v73/*: any*/),
            (v75/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectedBillableMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectedNonBillableMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectedTotalMinutes",
              "storageKey": null
            },
            (v72/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedMargin",
              "storageKey": null
            },
            (v100/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingCost",
              "storageKey": null
            },
            (v74/*: any*/),
            (v84/*: any*/),
            (v99/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nonBillableActualTimeAndExpenses",
              "storageKey": null
            },
            (v98/*: any*/),
            (v102/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskRegisteredMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectRegisteredMinutes",
              "storageKey": null
            }
          ],
          "storageKey": "financialNumbers(convertToProjectCurrency:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "companyProjectId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectServiceProjectType",
      "kind": "LinkedField",
      "name": "psProject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectHeader_psProject"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "d32eb7b3ca860fd4dcd60f20ddf1310a";

export default node;
